import { t, useLanguage, translateError } from "../../i18n";
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { publicAPI } from '../../services/api';
import { useCartStore } from '../../store';
import { Button } from '../../components/ui/button';
import { Utensils } from 'lucide-react';
import { motion } from 'framer-motion';
export default function TableEntry() {
  useLanguage();
  const {
    tableId
  } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const setTable = useCartStore(state => state.setTable);
  const clearCart = useCartStore(state => state.clearCart);
  useEffect(() => {
    const loadTable = async () => {
      try {
        const response = await publicAPI.getTable(tableId);
        const nextEstablishmentId = response.data.table.establishment_id;
        const {
          tableId: previousTableId,
          establishmentId: previousEstablishmentId
        } = useCartStore.getState();
        setData(response.data);
        if (previousTableId && previousTableId !== tableId || previousEstablishmentId && previousEstablishmentId !== nextEstablishmentId) {
          clearCart();
        }
        setTable(tableId, nextEstablishmentId);

        // Track menu view
        publicAPI.trackEvent({
          event_type: 'menu_viewed',
          table_id: tableId
        });
      } catch (err) {
        setError(t("Table non trouvée"));
      } finally {
        setLoading(false);
      }
    };
    loadTable();
  }, [tableId, setTable, clearCart]);
  if (loading) {
    return <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center">
        <div className="animate-pulse text-gray-400">{t("Chargement...")}</div>
      </div>;
  }
  if (error) {
    return <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4">
        <div className="text-center">
          <p className="text-red-500 mb-4">{translateError(error, 'Table non trouvée')}</p>
          <Button variant="outline" onClick={() => window.location.reload()}>{t("Réessayer")}

          </Button>
        </div>
      </div>;
  }
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-[#F9FAFB] flex flex-col">

      {/* Hero Section */}
      <div className="relative h-[50vh] bg-cover bg-center" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1770816307862-fd9e4940e6b6?w=800)'
    }}>

        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/70" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }}>

            <p className="text-sm font-medium text-blue-400 mb-1">{t("Table")}
              {data?.table?.table_number}
            </p>
            <h1 className="text-3xl font-bold tracking-tight mb-2" style={{
            fontFamily: 'Manrope'
          }}>
              {data?.establishment?.name}
            </h1>
            <p className="text-gray-300 text-sm">
              {data?.establishment?.description}
            </p>
          </motion.div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-6 -mt-4 relative z-10">
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="bg-white rounded-2xl shadow-lg p-6">

          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Utensils className="w-8 h-8 text-violet-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2" style={{
            fontFamily: 'Manrope'
          }}>{t("Bienvenue !")}

            </h2>
            <p className="text-gray-500">{t("Commandez directement depuis votre téléphone")}

            </p>
          </div>

          <Button data-testid="view-menu-btn" onClick={() => navigate('/menu')} className="w-full bg-[#111827] hover:bg-gray-800 text-white rounded-full py-6 text-lg font-semibold shadow-lg active:scale-95 transition-transform">{t("Voir le Menu")}

          </Button>

          <p className="text-center text-gray-400 text-xs mt-4">{t("Paiement optionnel • Service rapide")}

          </p>
        </motion.div>
      </div>
    </motion.div>;
}
